<template>
	<div class="checkout">
		
		<b-container fluid >
		<b-row class="mb-3">			

		 <b-col class="p-0">
		
		
		
        <!--<div class="breadcrumb-section mb-5">
            <b-container fluid>
                <b-row>
                    <b-col class="text-left">
                        <h5 class="mt-3 mb-3">MY ORDERS</h5>		
                    </b-col>
                    <b-col class="text-right">
                        <h6 class="mt-3 mb-3">HOME / ACCOUNT / ORDERS</h6>		
                    </b-col>
                </b-row>
            </b-container>
        </div>-->
		<b-container fluid>
			
		
			<b-row class="mt-3 mb-3">
				
                <b-col>
					<b-card class="p-4">
					<b-card-text>
						<b-row class="mb-1">
							
						<b-col cols="6">
						<b-table-simple  small responsive class="ivoiceTAle " style="border-right: 1px solid #c6c6c6;">
									<!--<caption></caption>-->
										<!--{{customer_data.shipping}}
										{{selectedItem.customer_data['shipping']}} -->
										<b-tr>
											<b-th colspan="2">Delivery Address:</b-th>
										</b-tr>
									
									<b-tbody >
										<b-tr>
											<b-td>
												<ul class="p-0" style="list-style: none;"> 
												<li> {{customer_data.shipping.firstname}} {{customer_data.shipping.lastname}}</li>
												<li> {{customer_data.shipping.address}}</li>
												<li> {{customer_data.shipping.city}}, {{customer_data.shipping.state}}</li>
												<li> {{customer_data.shipping.pincode}}</li><li> Ph:{{customer_data.shipping.phone}}</li>
												</ul>				
											</b-td>
											
										</b-tr>
										
								   </b-tbody>
								</b-table-simple>
							</b-col>

							<b-col cols="6">
								<!--<shipped-tracking></shipped-tracking> -->
								<b-table-simple  small caption-top responsive class="ivoiceTAle">
									
										<b-tr>
											<b-th colspan="2">More actions</b-th>
										</b-tr>
									
									<b-tbody >
										<b-tr>
											<b-td class="pt-2">
												<ul class="p-0">
													
													<li> <i class="fa fa-file" aria-hidden="true" style="font-size: 30px;
    color: #9016dc73"></i><span> Download Invoice </span>
	 <b-button variant="outline-primary"  style="float:right;" size="sm">Download</b-button>
	
	</li>
													
												</ul>
											</b-td>
										</b-tr>
								   </b-tbody>
								</b-table-simple> 
							</b-col>
						</b-row>
						

					</b-card-text>
				</b-card>
                </b-col>
			</b-row>
				
				<!-- {{selectedItem.order_status}} -->
				
			<b-row class="mb-3">
					
                <b-col>
				
				
				<b-card class="p-4">
						 <b-card-text>
				
                    <div v-for="item in orders" :key="item.id" style="background-color:#f9f9f9" class="mb-3 p-3">
						
                        <b-row class="font-sm">
							<b-col>Order Date: {{$moment(item.created_at).format('DD-MM-YYYY HH:mm:ss')}}</b-col>
							<b-col>Total Quantity: {{item.total_items}}</b-col>
							<b-col cols="5" class="text-right">Order ID: #{{item.uuid}}</b-col>
                        </b-row>
						<b-row class="font-sm">
							<b-col>
								<span>Order Status: </span>
								<b-badge pill :variant="$root.filterorderstatus(item.order_status)[0].color">{{$root.filterorderstatus(item.order_status)[0].label}}</b-badge>
							</b-col>
							<b-col>
								<span>Payment Status: </span>
								<b-badge pill :variant="$root.filterpaymentstatus(item.payment_status)[0].color">{{$root.filterpaymentstatus(item.payment_status)[0].label}}</b-badge>
							</b-col>
							<b-col cols="5" class="text-right">
								<span>Delivery Status: </span>
								<b-badge pill :variant="$root.filterdeliverystatus(item.delivery_status)[0].color">{{$root.filterdeliverystatus(item.delivery_status)[0].label}}</b-badge>
							</b-col>
                        </b-row>
						<b-row class="font-md mt-2">
							<b-col>
								<b-table :fields="orderfields" :items="JSON.parse(item.order_items)"  small class="mb-0">
									<template v-slot:cell(title)="row">
										<b-row>
											<b-col cols="2">
											<b-img :src="$root.MEDIAAPI+'toolimage/get_image?size=64x64&src='+row.item.image" width="120" alt="placeholder" class="border"></b-img>
											</b-col>
											
											<b-col cols="4">
											<ul >
												<li><span class="capitalize"><strong>{{row.item.title}}</strong></span></li>
												<li><span v-if="row.item.product_type==2">
										 <div class="p-0 m-0" v-for="(item, index) in row.item.variation_attributes" :key="item">
												<span class="text-capitalize "><!-- font-weight-bold -->  {{item}}: </span>
												<span class="text-uppercase">{{row.item.variations_selected[index]}}</span>
												
											</div>
									
										</span></li>
										<li><span>SKU : {{row.item.sku}} </span></li>
										<li><span>Brand : {{row.item.brand || '---'}} </span></li>
											
											</ul>
											</b-col>
										</b-row>										
                                    </template>
									<template v-slot:cell(price)="row">
                                        <!--<span>{{$root.currency()+$root.tofixed(row.item.special_price, 2)}} <del>{{$root.currency()+$root.tofixed(row.item.price, 2)}}</del></span> -->
										<span  v-if="row.item.special_price>0 && row.item.special_price!=null">{{$root.currency()+$root.tofixed(row.item.special_price, 2)}} 
																			<del>{{$root.currency()+$root.tofixed(row.item.price, 2)}}</del></span> 
																			<span v-else> 
																			{{$root.currency()+$root.tofixed(row.item.price, 2)}}</span>
										
										
										
                                    </template>
                                    <template v-slot:cell(total_price)="row">
                                        <!-- <span>{{$root.currency()+$root.tofixed(row.item.special_price * row.item.qty, 2)}}</span> -->
										<span v-if="row.item.special_price>0 && row.item.special_price!=null">{{$root.currency()+$root.tofixed(row.item.special_price * row.item.qty, 2)}}</span>
										<span v-else>{{$root.currency()+$root.tofixed(row.item.price * row.item.qty, 2)}}</span>
                                    </template>
                                </b-table>
								
							</b-col>
                        </b-row>
						
						<!--  <b-row>	
							<b-col>
								Shipping : {{item.order_items.shipping_cost}}
							</b-col>
                        </b-row>
						<b-row>	
							<b-col>
								Grand Total : {{item.order_items.amount_paid}}
							</b-col>
                        </b-row> -->
						 <!--<b-row class="mb-1" >-->
						<b-row class="mb-1" v-if="selectedItem.order_status=='pending' || selectedItem.order_status=='processing'">
							<b-col style="text-align:right;" v-if="displayCancelbtn==1" >  
								<!-- <b-link @click="orderOperation='cancel'" variant="outline-danger">Cancel Item</b-link><br /> -->
								<b-link @click="orderOperation='cancel'" variant="outline-danger"><b-badge pill variant="danger" @click="orderOperation='cancel'">  Cancel Item</b-badge></b-link><br />
								
								<!-- <b-link @click="orderOperation='return'">Return Item</b-link> -->
							</b-col >
							
						</b-row>
						
						<!-- selectedItem.order_status=='shipped' || -->
						<b-row class="mb-1" v-if="selectedItem.delivery_status=='delivered'">
							<b-col style="text-align:right;" v-if="displayReturnbtn==1">
								<!-- <b-link @click="orderOperation='return'">Return Item</b-link>-->
								<b-link @click="orderOperation='return'">
								<b-badge pill variant="danger"> Return Item</b-badge>
								</b-link>
							</b-col >
							
						</b-row>
						<b-row class="mb-1" v-if="selectedItem.order_status=='cancelled'" style="border: 1px solid #dee2e6;
    margin: 5px;">
							<b-col >
							
								<code>Cancellation Requested </code><br/>
								<small>Your request is being processed.It may take up to 1 day for your refund to be initiated.</small>
							</b-col>
							
						</b-row>
						
						<b-row class="mb-1" v-if="selectedItem.order_status=='Refunded' || selectedItem.delivery_status=='order_refunded'" style="border: 1px solid #dee2e6;
    margin: 5px;">
							<b-col >
							
								<code>Return has requested </code><br/>
								<small>Your request is being processed.It may take up to 1 day for your refund to be initiated.</small>
							</b-col>
							
						</b-row>
						
						 
                    </div>
					</b-card-text>
						</b-card>
                </b-col>
			</b-row>
			
			<b-row class="mb-3">
					
					<b-col>
						
						<b-card-text>
						
					<!-- -------------------- Cancellation Process --------------------------- -->		
						<b-row class="mb-1" v-if="orderOperation=='cancel'">
									
								<b-col cols="8">
								<b-card class="p-4">
							<div class="accordion" role="tablist">
								<b-card no-body class="mb-1">
								  <b-card-header header-tag="header" class="p-2" role="tab" v-b-toggle.login variant="info" :disabled="!(tabIndex==1)">
									<div class="stepnnumber">1</div>
									<span class="steptitle"> Easy Cancellation</span>
								  </b-card-header>
								  <b-collapse id="login" visible accordion="my-accordion" role="tabpanel">
									<b-card-body>
										<b-form-group :state="selectedOrderState.cancellation_reason"  label-for="statusC-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="Reason is required!" label-cols-sm="4" content-cols-sm label="* Reason for cancellation">
											<b-form-select v-model="selectedOrder.cancellation_reason" id="statusC-input" :state="selectedOrderState.cancellation_reason" v-on:change="selectedOrderState.cancellation_reason = null" size="sm">
											<b-form-select-option value="" hidden selected placeholder="Reason">*Select Reason</b-form-select-option>
											<!--<b-form-select-option v-for="option in cancellation_reason" :key="option.id" :value="option.title">{{option.title}}</b-form-select-option>-->
											 <b-form-select-option v-for="item in $root.cancellation_reason" v-bind:key="item.id" :value="item.slug">{{item.label}}</b-form-select-option>
											</b-form-select>
										</b-form-group>
									
									
									<b-form-group label-for="commentC-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedOrderState.cancellation_comments" invalid-feedback="This is required!" label-cols-sm="4" content-cols-sm label="Comments" >
													<b-form-textarea id="commentC-input" :state="selectedOrderState.cancellation_comments" v-model="selectedOrder.cancellation_comments" @focusin="selectedOrderState.cancellation_comments = null" size="sm" :maxlength="250" ></b-form-textarea>
									</b-form-group>
										
									
									
									  
									  <b-card-text >
										   <b-row class="pt-3">
												<b-col style="text-align:right;"><b-link class="btn-solid btn2 p-1"  v-b-toggle.refunt-status  @click="checkCancellation">Continue</b-link></b-col>
												<!-- v-on:mouseover="tabIndex=2" -->
												
											</b-row>
									  </b-card-text>
									 
									</b-card-body>
								  </b-collapse>
								</b-card>
								<b-card  class="mb-1">
								  <b-card-header header-tag="header" class="p-2" role="tab" v-b-toggle.refunt-status variant="info" :disabled="!(tabIndex==2)">
									<div class="stepnnumber">2</div>
									<span class="steptitle"> Refund Status</span>
								  </b-card-header>
								  <b-collapse id="refunt-status" visible accordion="my-accordion" role="tabpanel">
									<b-card-body>
									
										<!-- {{$root.currency()+$root.tofixed(orders[0].amount_paid, 2)}}-->
									  <b-card-text>{{$root.currency()+$root.tofixed(orders[0].price, 2)}} will be transferred within 7 business day (Bank holidays not included).</b-card-text>
									  <b-row class="pt-3">
											<b-col style="text-align:right;"><b-link class="btn-solid btn2 p-1" @click="requestCancellation">Request Cancellation</b-link></b-col>
											<!-- v-on:mouseover="tabIndex=2" -->
											
										</b-row>
									
									</b-card-body>
								  </b-collapse>
								</b-card>


								

								
							  </div>
							</b-card>
								
									</b-col>

									
								</b-row>
								
								
								
						<b-row class="mb-1" v-if="orderOperation=='return'">
									
								<b-col cols="8">
								<b-card class="p-4">
							<div class="accordion" role="tablist">
								<b-card no-body class="mb-1">
								  <b-card-header header-tag="header" class="p-2" role="tab" v-b-toggle.login variant="info" :disabled="!(tabIndex==1)">
									<div class="stepnnumber">1</div>
									<span class="steptitle"> Easy Return</span>
								  </b-card-header>
								  <b-collapse id="login" visible accordion="my-accordion" role="tabpanel">
									<b-card-body> 
										<b-form-group :state="selectedOrderState.return_reason"  label-for="returnR-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="Reason is required!" label-cols-sm="4" content-cols-sm label="* Reason for return">
											<b-form-select v-model="selectedOrder.return_reason" id="returnR-input" :state="selectedOrderState.return_reason" v-on:change="selectedOrderState.return_reason = null" size="sm">
											<b-form-select-option value="" hidden selected placeholder="Reason">*Select Reason</b-form-select-option>
											 <b-form-select-option v-for="item in $root.return_reason" v-bind:key="item.id" :value="item.slug">{{item.label}}</b-form-select-option>
											</b-form-select>
										</b-form-group>
									
									
									<b-form-group label-for="commentR-input" label-size="sm" label-class="mb-2" class="mb-1" :state="selectedOrderState.return_comments" invalid-feedback="This is required!" label-cols-sm="4" content-cols-sm label="Comments" >
													<b-form-textarea id="commentR-input" :state="selectedOrderState.return_comments" v-model="selectedOrder.return_comments" @focusin="selectedOrderState.return_comments = null" size="sm" :maxlength="250" ></b-form-textarea>
									</b-form-group>
										
									
									
									  
									  <b-card-text >
										   <b-row class="pt-3">
												<b-col style="text-align:right;"><b-link class="btn-solid btn2 p-1"  v-b-toggle.refuntReturn-status  @click="checkReturning">Continue</b-link></b-col>
												<!-- v-on:mouseover="tabIndex=2" -->
												
											</b-row>
									  </b-card-text>
									 
									</b-card-body>
								  </b-collapse>
								</b-card>
								<b-card  class="mb-1">
								  <b-card-header header-tag="header" class="p-2" role="tab" v-b-toggle.refuntReturn-status variant="info" :disabled="!(tabIndex==2)">
									<div class="stepnnumber">2</div>
									<span class="steptitle"> Refund Status</span>
								  </b-card-header>
								  <b-collapse id="refuntReturn-status" visible accordion="my-accordion" role="tabpanel">
									<b-card-body>
									
										<!-- {{$root.currency()+$root.tofixed(orders[0].amount_paid, 2)}}-->
									  <b-card-text>{{$root.currency()+$root.tofixed(orders[0].price, 2)}} will be transferred within 7 business day (Bank holidays not included).</b-card-text>
									  <b-row class="pt-3">
											<b-col style="text-align:right;"><b-link class="btn-solid btn2 p-1" @click="requestReturning">Request Refund</b-link></b-col>
											<!-- v-on:mouseover="tabIndex=2" -->
											
										</b-row>
									
									</b-card-body>
								  </b-collapse>
								</b-card>


								

								
							  </div>
							</b-card>
								<!-- <b-table-simple  small responsive class="ivoiceTAle " style="border-right: 1px solid #c6c6c6;">
											
												<b-tr>
													<b-th colspan="2">Delivery Address:</b-th>
												</b-tr>
											
											<b-tbody >
												<b-tr>
													<b-td>
														<ul class="p-0" style="list-style: none;">
														<li> {{customer_data.shipping.firstname}} {{customer_data.shipping.lastname}}</li>
														<li> {{customer_data.shipping.address}}</li>
														<li> {{customer_data.shipping.city}}, {{customer_data.shipping.state}}</li>
														<li> {{customer_data.shipping.pincode}}</li><li> Ph:{{customer_data.shipping.phone}}</li>
														</ul>				
													</b-td>
													
												</b-tr>
												
										   </b-tbody>
										</b-table-simple>-->
									</b-col>

									<!-- <b-col cols="6">
										<b-table-simple  small caption-top responsive class="ivoiceTAle">
											
												<b-tr>
													<b-th colspan="2">More actions</b-th>
												</b-tr>
											
											<b-tbody >
												<b-tr>
													<b-td class="pt-2">
														<ul class="p-0">
															
														<li> <i class="fa fa-file" aria-hidden="true" style="font-size: 30px;
			color: #9016dc73"></i><span> Download Invoice </span>
			 <b-button variant="outline-primary"  style="float:right;" size="sm">Download</b-button>
			
			</li>
															
														</ul>
													</b-td>
												</b-tr>
										   </b-tbody>
										</b-table-simple> 
									</b-col> -->
								</b-row>

						</b-card-text>
					
					</b-col>
				</b-row>

				<b-row v-if="shippingBy=='shiprocket'">
						<b-col>
						<shipped-tracking :awb_code="selectOrderElement.awb_code" :shipment_id="selectOrderElement.shipment_id" :shipment_order_id="selectOrderElement.shipment_id" :shippingBy="shippingBy" :srToken="srToken" :orderId="$route.params.orderid" :shipmenttrackactivities="shipment_track_activities" :currentshipment_status="currentshipment_status"></shipped-tracking>
						</b-col>
				</b-row>
			
		</b-container>
		<!-- <b-container fluid>
			<product-swiper :products="related_products" :showQuickViewListener="$root.showQuickView" heading="Best Selling Products"></product-swiper>
		</b-container> -->
		
		
		</b-col>
		</b-row>
		</b-container>
		
	</div>
</template>
<script>
/*import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
//import ProductSwiper from "@/components/product-swiper.vue";
import Quickview from "@/components/quickview.vue";
import TreeviewPage from "@/components/common/nevleft.vue"; */
import Shippedtracking from "@/components/shipped-tracking.vue"; 
import '@/assets/checkout.scss';
export default {
	name: 'Dashboard',
	beforeCreate: function() {
        document.body.className = 'home';
    },
	components: {
        //"top-header": Header,
		//"top-footer": Footer,
		//"product-swiper": ProductSwiper,
		//"quickview": Quickview,
		//"top-nevleft": TreeviewPage,
		"shipped-tracking": Shippedtracking,
	},
	mounted(){
        this.initload();
		
		var date1 = new Date(); 
		var date2 = new Date('01-07-2021 09:03:57'); 
		if (date1.getTime() < date2.getTime()){
			console.log("date is valid"); 
		}else if (date1.getTime() > date2.getTime()){
			//document.write("date is expired"); 
			console.log("date is expired"); 
		}else{
			//document.write("date is valid today only"); 
			console.log("date is valid today only"); 
			
			}
        
	},
	data() {
		return{
            modal_data: {
                price: 0,
                special_price: 0
			},
			slide:0,
			orders: [],
			orderfields: [
                { key: 'title', label: 'Product'},
                //{ key: 'sku', label: 'SKU', class: 'text-right'},
                { key: 'price', label: 'Price', class: 'text-center'},
                { key: 'qty', label: 'Qty', class: 'text-center'},
                { key: 'total_price', label: 'Total Price', class:'text-right'},
            ],
			url: this.$root.WEBURL+'customer-orders',
			//url2: this.$root.WEBURLNEW+'order-detail',
			url2: this.$root.WEBURL+'order-detail',
			updateStatusCanUrl: this.$root.WEBAPI+'sellerapi/order-status-update-cancel',
			updateStatusReturnUrl: this.$root.WEBAPI+'sellerapi/order-status-update-return',
			customer_data:{
                    'billing':{},
                    'shipping':{}
                },
			selectedItem: {
                id: 0,
                order_items: [],
                customer_data:{
                    'billing':{},
                    'shipping':{}
                },
                price:0,
                commission: 0,
				order_status:[],
				delivery_status:[],
				payment_status:[],
            },
			orderOperation:'',
			tabIndex:1,		
			selectedOrder:{
				cancellation_reason:'',
				cancellation_comments:'',
				return_reason:'',
				return_comments:'',
			},
			selectedOrderState:{
				cancellation_reason:null,
				cancellation_comments:null,
				return_reason:null,
				return_comments:null,
			},
			
			shippingBy:'',
			selectOrderElement:{
				awb_code:'',
				label_url:'',
				manifest_url:'',
				pickup_token_number:'',
				shipment_id:'',
				shipment_order_id:'',
			},
			displayCancelbtn:0,
			displayReturnbtn:0,
			srToken:'',
			shipment_track_activities:[],
			currentshipment_status:0,
		};
	},
	methods: {
		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.modal_data.gallery_images = JSON.parse(item.gallery_images);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},
		initload(){
			var self = this;
			
			/* ---------- SR Token generate -------- */
			if(self.srToken==''){
				var shipRocketUrl='https://apiv2.shiprocket.in/v1/external/auth/login';
				self.axios.post(shipRocketUrl, {
					email: "mahato@alluraa.com",
					password: "Mahato@123"
				})
				.then(function (response) {
					//console.log(response);
					var objResp = response.data;
					self.srToken = objResp.token;
					
					//console.log('MyToken'+self.srToken);

					

				})
				.catch(function (error) {
					alert(error);
				});
			}
			/* ---------- E N D SR -------- */
			self.axios.post(self.url2, {
                accesskey: self.$root.customer_info.access_key,
                orderid: this.$route.params.orderid,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
                    self.orders = response.data.result.orders;
					self.customer_data = JSON.parse(response.data.result.orders[0].customer_data);
					//console.log(self.orders[0]);
					self.selectedItem = Object.assign({}, self.orders[0]);
                    //console.log(self.share_data);
					
					
					/* ******** Cancel Btn Status************* */
					//console.log(JSON.stringify(self.orders));
					
					var orderCreateDate = self.orders[0]['created_at'];
					var orderUpdatedDate = self.orders[0]['updated_at'];
					var startDateNew =  self.$moment(orderCreateDate).format('DD.MM.YYYY h:mm:ss');
					var new_date = self.$moment(startDateNew, "DD.MM.YYYY h:mm:ss").add(2, 'hours');
					//var new_date = self.$moment(startDateNew, "DD.MM.YYYY h:mm:ss").add(7, 'days');
					
					var endTime = self.$moment(new_date); //.format('DD.MM.YYYY h:mm:ss ');
					var currentDate =  self.$moment(); //.format('DD.MM.YYYY h:mm:ss');
					/* 
					console.log('startTime:'+startDateNew);
					console.log('endTime:'+endTime);
					console.log('currentDate:'+currentDate); */
					if(endTime>=currentDate){
						//console.log('Display');
						self.displayCancelbtn=1;
					}else{
						//console.log('noDisplay');
						self.displayCancelbtn=0;
					}
					
					/* *************************** */
					/* ******** Return  Btn Status************* */
					var updatedDateNew 	=  self.$moment(orderUpdatedDate).format('DD.MM.YYYY h:mm:ss');
					//var new_dateReturn 		= self.$moment(updatedDateNew, "DD.MM.YYYY h:mm:ss").add(2, 'hours');
					var new_dateReturn 	= self.$moment(updatedDateNew, "DD.MM.YYYY h:mm:ss").add(2, 'days');
					
					var endTimeReturn = self.$moment(new_dateReturn); //.format('DD.MM.YYYY h:mm:ss ');
					var currentDateReturn =  self.$moment(); //.format('DD.MM.YYYY h:mm:ss');
					
					if(endTimeReturn>=currentDateReturn){
						//console.log('Display');
						self.displayReturnbtn=1;
					}else{
						//console.log('noDisplay');
						self.displayReturnbtn=0;
					}
					
					/* **************************************** */
					
				/* ************* TRACKING SHIPMENT ************* */	
					var sRshippingdata = self.orders[0].shipping_data_sr;
					if(self.orders[0].shipment_track_activities!=''){
						self.shipment_track_activities = JSON.parse(self.orders[0].shipment_track_activities);
					}
					self.currentshipment_status=self.orders[0].shipment_status;
					
					if(sRshippingdata!=''){
							
						var sRshippingdataObj =  JSON.parse(sRshippingdata);
						var payload =sRshippingdataObj.payload;
						  self.selectOrderElement.awb_code = payload.awb_code;
						  self.selectOrderElement.label_url = payload.label_url;
						  self.selectOrderElement.manifest_url = payload.manifest_url;
						  self.selectOrderElement.pickup_token_number = payload.pickup_token_number;
						  self.selectOrderElement.shipment_id = payload.shipment_id;
						  self.selectOrderElement.shipment_order_id = payload.order_id;
						  
						 // console.log(self.selectOrderElement);
						  //self.selectedProcessby= 'shiprocket';
						  self.shippingBy = 'shiprocket';
						  
						  
						   /* var awb = '19041194396192';
						   var shipment_id = '139321670';
						   var addressList ={awbs:[awb]};
						  console.log(addressList);
						  self.axios({
								url: "https://apiv2.shiprocket.in/v1/external/courier/track/shipment/"+shipment_id,
								//url: "https://apiv2.shiprocket.in/v1/external/courier/track/awb/"+awb,
								//url: "https://apiv2.shiprocket.in/v1/external/courier/track/awbs",
								method: 'GET',
								headers: {"Content-Type": "application/json","Authorization": 'Bearer '+self.srToken},
								//data:addressList 
								})
							  .then(res => {
								console.log(`Axios Call completed: ${res}`);
								
							  }); */
							  
							  
							  /*curl --location --request POST 'https://apiv2.shiprocket.in/v1/external/courier/track/awbs' \
--header 'Content-Type: application/json' \
--header 'Authorization: Bearer {{token}}' \
--data-raw '{
    "awbs": ["788830567028","788829354408"]
}'*/
					
					
					}else{
						/* For Other Shipping Option*/
						//self.tabIndexothers=1;
						//self.selectedProcessby= 'other';
						self.shippingBy = 'other';
					}
					
					
					
					
					
					
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		checkCancellation(){
		var self = this;
			var valid = true;
			console.log(this.selectedOrder.cancellation_reason.length);
			console.log(this.selectedOrder.cancellation_reason);
			
			if(this.selectedOrder.cancellation_reason.length<1) {
			console.log('ddddd');
					self.selectedOrderState.cancellation_reason = false;
					valid = false;
				}else{
				console.log('rrr');
					self.selectedOrderState.cancellation_reason = true;
				}
				
			if(valid){
				
				self.tabIndex=2;
			}
		
		},
		requestCancellation(){
			console.log('ev');
				var self = this;
			//self.tabIndex=Number(self.tabIndex)+1;
			var orderId = self.selectedItem.uuid;
			self.axios.post(self.updateStatusCanUrl, {
				accesskey: self.$session.get('access_key'),
				orderId: orderId,
				orderCancel: self.selectedOrder,
				
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//self.$bvModal.hide('my-model');
					self.orderOperation='';
					self.initload();
					
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		checkReturning(){
		var self = this;
			var valid = true; 
			
			if(this.selectedOrder.return_reason.length<1) {
		
					self.selectedOrderState.return_reason = false;
					valid = false;
				}else{
				
					self.selectedOrderState.return_reason = true;
				}
				
			if(valid){
				
				self.tabIndex=2;
			}
		
		},
		requestReturning(){
			console.log('ev');
				var self = this;
			//self.tabIndex=Number(self.tabIndex)+1;
			var orderId = self.selectedItem.uuid;
			self.axios.post(self.updateStatusReturnUrl, {
				accesskey: self.$session.get('access_key'),
				orderId: orderId,
				orderCancel: self.selectedOrder,
				
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//self.$bvModal.hide('my-model');
					self.orderOperation='';
					self.initload();
					
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		}
	}
}
</script>

<style  lang="scss">

  
  .ivoiceTAle{
		.table td,.table th{
			border-top: 0px solid #dee2e6 !important;
		}
		.invoiceTitle{
			text-align:center !important;
			border-top: 1px solid #dee2e6 !important;
			border-bottom: 1px solid #dee2e6 !important;
		}
		.tblbr{
			border-right: 1px solid #dee2e6 !important;
		}
	}
	.collapsed{
		max-width: 100% !important;
	}
</style>